import { render, staticRenderFns } from "./ProductSegmentDialog.vue?vue&type=template&id=c42748d0&scoped=true"
import script from "./ProductSegmentDialog.vue?vue&type=script&lang=ts"
export * from "./ProductSegmentDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProductSegmentDialog.vue?vue&type=style&index=0&id=c42748d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42748d0",
  null
  
)

export default component.exports